import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HttpClient } from '@angular/common/http';
import { API_BOOK } from 'src/@core/services/util/api.endpoints';
import { AppService } from 'src/@core/services/app.service';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { NotificationService } from 'src/@core/services/notification.service';
import { entityTypes, roles } from 'src/app/shared/helpers/roles-permissions';
import { EmployerUploadService } from 'src/@core/services/employer/employer-upload.service';
import moment from 'moment';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'hour4u-admin-book-society-dialog',
  templateUrl: './book-society-dialog.component.html',
  styleUrls: ['./book-society-dialog.component.scss']
})
export class BookSocietyDialogComponent implements OnInit {
  society: any;
  bookingDate: any;
  bookingTime: any;
  numberOfHours: any;
  totalExpectedAmount: any;
  profile = this.appService.getCurrentAccount();
  isButtonDisabled: boolean = false;
  isLoading: boolean = false;
  isFileUploading: boolean = false;
  services: any[] = [];
  selectedServicesArray: any[] = [];
  selectedServices: any = null;
  currentUserRole: any = null;
  roles = roles;
  entityTypes = entityTypes;
  selectedFileNames: string[] = [];
  attachmentsArray: any[] = [];
  additionalInfo: any = null;
  diameter = 30;
  loaderColor: string;
  mode = 'indeterminate';
  selectedTab: number = 0;
  inquiryForm: FormGroup;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<BookSocietyDialogComponent>,
    private http: HttpClient,
    private appService: AppService,
    private router: Router,
    private notify: NotificationService,
    private employerUploadService: EmployerUploadService,
    private _fb: FormBuilder
  ) { }

  ngOnInit() {
    if (this.profile && this.profile.entity && this.profile.entity.id) {
      this.selectedTab = 0;
    } else {
      this.inquiryForm = this._fb.group({
        name: ["", [Validators.required]],
        companyName: [""],
        phone: ['', [Validators.required, Validators.pattern('^[6-9][0-9]{9}$'), Validators.minLength(10), Validators.maxLength(10)]],
        email: ["", [Validators.required, Validators.email]],
      });
      this.selectedTab = 1;
    }

    console.log(this.data)
    this.society = this.data.society;
    this.bookingDate = this.data.bookingDate;
    this.bookingTime = this.data.bookingTime;
    this.numberOfHours = this.data.numberOfHours;
    this.services = this.data.services;
    this.currentUserRole = this.data.currentUserRole;

    console.log(this.services)
    if (this.services && this.services.length) {
      let selectedServices = [];
      this.selectedServicesArray = [];
      this.services.forEach(ele => {
        selectedServices.push(ele.label);
      })
      this.selectedServicesArray = selectedServices;
      this.selectedServices = selectedServices.join(", ");
    }
    let rentPerHour = 0;
    if (this.data.society.rentPerDay)
      rentPerHour = this.data.society.rentPerDay / 10;
    const numberOfHours = this.data.numberOfHours;

    const baseRent = rentPerHour * numberOfHours;
    const platformFees = baseRent * 0.05;
    const serviceChargesAndTaxes = (baseRent + platformFees) * 0.18;

    this.totalExpectedAmount = baseRent + platformFees + serviceChargesAndTaxes;
  }

  razorPayOptions = {
    "amount": 0,
    currency: 'INR',
    key: environment.rezorpayKey,
    order_id: '',
    invoice_id: '',
    "handler": (paymentResponse) => {
      this.notify.showMessage("Payment success and Booking saved Redirecting to my bookings ", 2000);
      this.dialogRef.close(true);
      this.router.navigate(['/bookings']);
      console.log('Payment successful:', paymentResponse);
    },
    "modal": {
      "ondismiss": () => {
        this.dialogRef.close();
      }
    }
  };

  bookAndPay() {
    this.isButtonDisabled = true;
    this.isLoading = true;
    console.log(this.profile)

    if (this.selectedTab == 1) {
      if (!this.inquiryForm.valid) {
        this.inquiryForm.markAllAsTouched();
        this.isButtonDisabled = false;
        this.isLoading = false;
        return;
      } else {
        console.log(this.inquiryForm.value)
        this.isButtonDisabled = false;
        this.isLoading = false;
        this.selectedTab = 2;
        return;
      }
    }

    if (this.selectedTab == 2) {
      this.isButtonDisabled = false;
      this.isLoading = false;
      console.log("$$$$$$$$$$$$$$$$$$")
    }

    if (this.selectedTab == 0) {
      console.log(this.profile, this.data, this.bookingTime)
      const requestBody = {
        "enquiry": {
          "additionalRequirements": this.additionalInfo,
          "attachment": this.attachmentsArray,
          "companyName": this.data.society.contactName,
          "email": this.profile.entity.email,
          "entity": {
            "address": this.profile.entity.entityMeta.address,
            "email": this.profile.entity.email,
            "entityId": this.profile.entity.id,
            "mobile": this.profile.entity.mobile,
            "name": this.profile.entity.entityMeta.name
          },
          "location": this.data.society.location,
          "mobile": this.profile.entity.mobile,
          "name": this.profile.entity.entityMeta.name,
          "numberOfHours": this.data.numberOfHours,
          "services": this.selectedServicesArray,
          "startDate": moment(this.data.bookingDate).format('YYYY-MM-DD'),
          "startTime": this.bookingTime
        },
        "propertyId": this.data.society.id
      }

      this.http.post(API_BOOK, requestBody).subscribe(
        (response: any) => {
          this.isLoading = false;
          this.isButtonDisabled = true;
          this.notify.showMessage("Enquiry sent Successfully!", 2000);
          this.closeDialog();
          this.router.navigateByUrl(`/bookings`);
        },
        (error) => {
          console.error('Error while booking society:', error);
        }
      );
    }
  }

  updateBookingStatus(bookingId: string) {
    const updateData = {
      bookingStatus: 'APPROVED'
    };

    this.http.put<any>(`${API_BOOK}/${bookingId}`, updateData)
      .subscribe(
        (response) => {
          console.log('Booking status updated:', response);
        },
        (error) => {
          console.error('Error updating booking status:', error);
        }
      );
  }

  onFileSelected(event: Event) {
    this.isFileUploading = true;
    const inputElement = event.target as HTMLInputElement;

    if (inputElement.files && inputElement.files.length > 0) {
      this.attachmentsArray = [];

      for (let i = 0; i < inputElement.files.length; i++) {
        const file = inputElement.files[i];

        // Upload the file to S3 using the existing function
        this.employerUploadService.uploadProfileImage(file).subscribe(
          (s3File) => {
            this.isFileUploading = false;
            console.log('File uploaded successfully:', s3File);

            this.attachmentsArray.push(s3File.key);
            this.selectedFileNames.push(file.name);
          },
          (error) => {
            this.isFileUploading = false;
            console.error('Error uploading file:', error);
          }
        );
      }
    }
  }

  closeDialog() {
    this.dialogRef.close();
  }
}
